module.exports = __webpack_public_path__ + "img/red_053.aa9c1540.png";